import noTasksFound from 'media/svgs/no-pages-found.svg';
import { useTranslation } from 'react-i18next';

export const NoAddedPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-2">
      <img
        src={noTasksFound}
        alt={t('no_pages.image_alt', 'No Tasks')}
      />
      <div className="text-lg font-semibold">
        {t('no_pages.title', "Let's get started")}
      </div>
      <div className="text-center text-sm font-normal">
        {t('no_pages.description', 'Add a page for feedback by clicking below, or add a task')}
      </div>
    </div>
  );
};